// App.jsx
import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom/client";
import { Button, Input, Label } from "reactstrap";
import "gridstack/dist/gridstack.min.css";
import { GridStack } from "gridstack";
import { v4 as uuidv4 } from "uuid";


import { Line, Bar, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import TableView from "../Charts/TableView";

import ReactApexChart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { store } from "../../..";
import {
  FETCH_DASHBOARD_LIST,
  GET_DASHBOARD_ELEMENTS,
  GET_DASHBOARD_FAV_PROMPT_LIST,
  GET_GROUP_BOT_LIST,
  SAVE_DASHBOARD,
  UPDATE_DASHBOARD_DETAILS,
} from "../../../slices/dashboard/thunk";
import {
  set_component_to_canvas,
  set_dashboard_category,
  set_dnd_components,
  set_drag_drop_canvas_loader,
  set_edit_chart_modal_status,
  set_edit_element_id,
  set_rename_modal,
  set_temp_title,
  set_title_element,
  set_title_id,
  setnew_element,
} from "../../../slices/dashboard/reducer";
import {
  bot_list,
  Get_Favourite_Prompt_Category,
} from "../../../slices/thunks";
import { groupByPromptCategory } from "../../../slices/layouts/utils";
import { dashboard_element } from "../../../helpers/fakebackend_helper";
import TableChart from "../Charts/TableChart";
import { reviveFunctions } from "../../../slices/layouts/utils";

import { set_bread_crum } from "../../../slices/header/reducer";
import { group_list, reset_group_Owner } from "../../../slices/thunks";

import N_C_loader from "./N_C_loader";
import HorizontalBarChart from "../Charts/HorizontalBarChart";
import { close_confirm_modal, open_confirm_modal } from "../../../slices/Confirm_Modal/reducer";
import { waitForDecision } from "../../../utility/wait_for_confirmation";
import RenameModal from "./RenameModal";
import Timeseries_chart from "../Charts/Timeseries_chart";
import Chart_Edit_Values_Popup from "../../DragDrop/Charts/Chart_Edit_values/Chart_Edit_Values_Popup";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

// ---------------- Chart.js Data ----------------
const lineData = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May"],
  datasets: [
    {
      label: "Sales",
      data: [65, 59, 80, 81, 56],
      borderColor: "rgb(75,192,192)",
      backgroundColor: "rgba(75,192,192,0.2)",
    },
  ],
};

const barData = {
  labels: ["Red", "Blue", "Yellow", "Green"],
  datasets: [
    {
      label: "Votes",
      data: [12, 19, 3, 5],
      backgroundColor: ["red", "blue", "yellow", "green"],
    },
  ],
};

const pieData = {
  labels: ["Apples", "Bananas", "Cherries"],
  datasets: [
    {
      data: [10, 20, 30],
      backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
    },
  ],
};

// ---------------- ApexCharts Config ----------------
const apexConfigs = {
  area: {
    series: [{ name: "Area", data: [10, 41, 35, 51, 49, 62, 69] }],
    options: {
      chart: {
        type: "area",
        toolbar: { show: false },
      },
      xaxis: { categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"] },
    },
  },
  barMarker: {
    series: [{ data: [20, 30, 40, 50] }],
    options: {
      chart: { type: "bar", toolbar: { show: false } },
      plotOptions: { bar: { distributed: true } },
    },
  },
  heatmap: {
    series: [
      { name: "Metric1", data: [10, 20, 30, 40, 50] },
      { name: "Metric2", data: [15, 25, 35, 45, 55] },
    ],
    options: {
      chart: { type: "heatmap" },
      dataLabels: { enabled: false },
      toolbar: { show: false },
    },
  },
  lineBar: {
    series: [
      { name: "Sales", type: "column", data: [23, 11, 22, 27, 13, 22, 37] },
      { name: "Revenue", type: "line", data: [44, 55, 41, 67, 22, 43, 21] },
    ],
    options: { chart: { type: "line" }, stroke: { width: [0, 4] } },
  },
  multiAxis: {
    series: [
      { name: "Temperature", type: "line", data: [30, 40, 35, 50, 49, 60, 70] },
      { name: "Rainfall", type: "column", data: [20, 29, 37, 36, 44, 45, 50] },
    ],
    options: {
      chart: { type: "line", height: 350, toolbar: { show: false } },
      stroke: { width: [4, 0] },
      dataLabels: { enabled: true, enabledOnSeries: [0] },
      labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
      xaxis: { type: "category" },
      yaxis: [
        { title: { text: "Temperature (°C)" } },
        { opposite: true, title: { text: "Rainfall (mm)" } },
      ],
    },
  },
  rangeBar: {
    series: [
      {
        data: [
          { x: "Team A", y: [1, 5] },
          { x: "Team B", y: [4, 6] },
        ],
      },
    ],
    options: {
      chart: { type: "rangeBar" },
      plotOptions: { bar: { horizontal: true } },
      toolbar: { show: false },
    },
  },
  scatter: {
    series: [
      {
        name: "A",
        data: [
          [5.4, 170],
          [5.8, 165],
          [6.1, 180],
        ],
      },
      {
        name: "B",
        data: [
          [5.5, 160],
          [6.3, 175],
          [6.6, 188],
        ],
      },
    ],
    options: { chart: { type: "scatter" }, xaxis: { tickAmount: 10 } },
  },
  donut: {
    series: [44, 55, 13, 43, 22],
    options: {
      chart: { type: "donut", toolbar: { show: false } },
      labels: ["Apple", "Mango", "Orange", "Watermelon", "Banana"],
    },
  },
  stackedBar: {
    series: [
      { name: "Q1", data: [44, 55, 41, 67, 22, 43] },
      { name: "Q2", data: [13, 23, 20, 8, 13, 27] },
    ],
    options: {
      chart: { type: "bar", stacked: true, toolbar: { show: false } },
      xaxis: { categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"] },
    },
  },
};

// ---------------- Chart Mounting ----------------
let gridInstance = null;

function mountChartInto(el, type, graph_data , title , gs_id) {

  let data = null;

  if (graph_data) {
    data = JSON.parse(graph_data);
  }
  if (!el) return;
  if (el.__reactRoot) return;

  // wrapper with close button
  const wrapper = document.createElement("div");
  wrapper.className = "chart-wrapper";
  wrapper.style.position = "relative";
  wrapper.style.width = "100%";
  wrapper.style.minWidth = "200px";
  wrapper.style.height = "100%";

  // Chart Title
  const titleEl = document.createElement("span");
  titleEl.innerText = title ?? "Dashboard Chart"; 
  titleEl.className = "chart_name_dashboard";
  // <-- Change this text to your desired title
  titleEl.style.textAlign = "center";
  titleEl.style.fontFamily = "Poppins, sans-serif";
  titleEl.style.margin = "5px 0";
  titleEl.style.fontWeight = "600";
  wrapper.appendChild(titleEl);


  const closeBtn = document.createElement("button");
  closeBtn.innerHTML = "✖";
  closeBtn.className = "chart-close-btn";
  closeBtn.style.position = "absolute";
  closeBtn.style.top = "-29px";
  closeBtn.style.right = "5px";
  closeBtn.style.background = "transparent";
  closeBtn.style.border = "1px solid #ddd";
  closeBtn.style.cursor = "pointer";
  closeBtn.style.fontSize = "12px";
  closeBtn.style.zIndex = "9";
  closeBtn.style.borderRadius = "27px";
// dropdwown wrap=============================================== uncomment to enable dropdown functionality
  // === Settings Container ===
const settingsWrapper = document.createElement("div");
settingsWrapper.className = "settings-wrapper";
settingsWrapper.style.position = "absolute";
settingsWrapper.style.top = "-29px";
settingsWrapper.style.right = "0px";
settingsWrapper.style.zIndex = "9";

// Toggle Button
const toggleBtn = document.createElement("button");
toggleBtn.innerHTML = '<i class="ri-more-2-line"></i>'; 
toggleBtn.className = "settings-toggle-btn";
toggleBtn.style.background = "transparent";
toggleBtn.style.border = "1px solid #ddd";
toggleBtn.style.cursor = "pointer";
toggleBtn.style.fontSize = "12px";
toggleBtn.style.borderRadius = "4px";
settingsWrapper.appendChild(toggleBtn);

// Dropdown Menu
const dropdownMenu = document.createElement("div");
dropdownMenu.className = "settings-dropdown";
dropdownMenu.style.display = "none"; 
dropdownMenu.style.position = "absolute";
dropdownMenu.style.top = "25px";
dropdownMenu.style.right = "0";
dropdownMenu.style.background = "#fff";
dropdownMenu.style.border = "1px solid #ddd";
dropdownMenu.style.padding = "5px";
dropdownMenu.style.borderRadius = "6px";
dropdownMenu.style.boxShadow = "0px 2px 6px rgba(0,0,0,0.15)";
dropdownMenu.style.minWidth = "max-content";
settingsWrapper.appendChild(dropdownMenu);

// Option 1: Remove Element
const removeBtn = document.createElement("button");
removeBtn.innerText = "Delete Element";
removeBtn.style.width = "100%";
removeBtn.style.background = "transparent";
removeBtn.style.border = "none";
removeBtn.style.textAlign = "left";
removeBtn.style.padding = "5px";
removeBtn.style.cursor = "pointer";
removeBtn.style.borderBottom = "1px solid #ddd";
removeBtn.onclick = () => {
    dropdownMenu.style.display = dropdownMenu.style.display === "none" ? "block" : "none";
    const gridItem = el.closest(".grid-stack-item");
    if (gridItem && gridInstance) {
       store.dispatch(open_confirm_modal(" Are you sure you want to delete this element.")) 
      
         waitForDecision().then((decision)=>{
      
          
          if(decision){
      
      
      gridItem.remove();
      gridInstance.removeWidget(gridItem, false);
      
            
                
             }
      
      
             store.dispatch(close_confirm_modal())
      
         });
      
      // gridItem.remove();
      // gridInstance.removeWidget(gridItem, false);
      // gridInstance.removeWidget(gridItem);
    }
  };
dropdownMenu.appendChild(removeBtn);

// Option 2: Rename Element
const renameBtn = document.createElement("button");
renameBtn.innerText = "Rename";
renameBtn.style.width = "100%";
renameBtn.style.background = "transparent";
renameBtn.style.border = "none";
renameBtn.style.textAlign = "left";
renameBtn.style.padding = "5px";
renameBtn.style.cursor = "pointer";
renameBtn.style.borderBottom = "1px solid #ddd";
renameBtn.onclick=()=>{

  store.dispatch(set_rename_modal(true))
  console.log(gs_id , "GS _ID value ")
  store.dispatch(set_title_id(gs_id))
  dropdownMenu.style.display = dropdownMenu.style.display === "none" ? "block" : "none";

}
dropdownMenu.appendChild(renameBtn);

// Option 3: Rename Element
const edit_button = document.createElement("button");
edit_button.innerText = "Edit";
edit_button.style.width = "100%";
edit_button.style.background = "transparent";
edit_button.style.border = "none";
edit_button.style.textAlign = "left";
edit_button.style.padding = "5px";
edit_button.style.cursor = "pointer";

edit_button.onclick=()=>{

  store.dispatch(set_edit_chart_modal_status(true))
  console.log(gs_id , "GS _ID value ")
  store.dispatch(set_edit_element_id(gs_id))
  dropdownMenu.style.display = dropdownMenu.style.display === "none" ? "block" : "none";

}
dropdownMenu.appendChild(edit_button);



// Toggle dropdown on button click
toggleBtn.onclick = () => {
  dropdownMenu.style.display = dropdownMenu.style.display === "none" ? "block" : "none";
};

// Append settings wrapper
wrapper.appendChild(settingsWrapper);

// dropdown end=========================================================================================



  closeBtn.onclick = () => {
    const gridItem = el.closest(".grid-stack-item");
    if (gridItem && gridInstance) {
      gridItem.remove();
      gridInstance.removeWidget(gridItem, false);
      // gridInstance.removeWidget(gridItem);
    }
  };

  el.innerHTML = "";
  el.appendChild(wrapper);
  // wrapper.appendChild(closeBtn);

  const chartContainer = document.createElement("div");
  chartContainer.style.width = "100%";
  chartContainer.style.height = "100%";
  wrapper.appendChild(chartContainer);

  const root = ReactDOM.createRoot(chartContainer);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    // plugins: {
    //   legend: {
    //     position: "top",
    //   },
    //   customToolbar: {
    //     position: "right",
    //     offset: 25,
    //   },
    // },
  };

  // const customToolbar = {
  //   id: "customToolbar",
  //   afterDraw(chart, args, options) {
  //     const { ctx, chartArea } = chart;

  //     ctx.save();
  //     ctx.fillStyle = "#fff";
  //     ctx.strokeStyle = "#ccc";
  //     ctx.lineWidth = 1;
  //     ctx.fillRect(chartArea.right - 50, chartArea.top + 25, 25, 25);
  //     ctx.strokeRect(chartArea.right - 50, chartArea.top + 25, 25, 25);

  //     ctx.fillStyle = "#000";
  //     ctx.font = "12px Poppins";
  //     ctx.fillText("↻", chartArea.right - 43, chartArea.top + 43); // Example: Reset icon
  //     ctx.restore();
  //   },
  // };

  let chart;
  const table_data = data;
  const data_set = data?.formatted_data_for_visualization;

  try {
    switch (type) {
      case "line":
        const data_ = {
          labels: data_set.xValues,
          datasets: data_set.yValues.map((item, index) => {
            return {
              label: item.label,
              data: item.data,
            };
          }),
          // datasets: [
          //     {
          //         label: "Sales Analytics",
          //         fill: true,
          //         lineTension: 0.5,
          //         backgroundColor: lineChartColor[0],
          //         borderColor: lineChartColor[1],
          //         borderCapStyle: 'butt',
          //         borderDash: [],
          //         borderDashOffset: 0.0,
          //         borderJoinStyle: 'miter',
          //         pointBorderColor: lineChartColor[1],
          //         pointBackgroundColor: "#fff",
          //         pointBorderWidth: 1,
          //         pointHoverRadius: 5,
          //         pointHoverBackgroundColor: lineChartColor[1],
          //         pointHoverBorderColor: "#fff",
          //         pointHoverBorderWidth: 2,
          //         pointRadius: 1,
          //         pointHitRadius: 10,
          //         data: [65, 59, 80, 81, 56, 55, 40, 55, 30, 80]
          //     },
          //     {
          //         label: "Monthly Earnings",
          //         fill: true,
          //         lineTension: 0.5,
          //         backgroundColor: lineChartColor[2],
          //         borderColor: lineChartColor[3],
          //         borderCapStyle: 'butt',
          //         borderDash: [],
          //         borderDashOffset: 0.0,
          //         borderJoinStyle: 'miter',
          //         pointBorderColor: lineChartColor[3],
          //         pointBackgroundColor: "#fff",
          //         pointBorderWidth: 1,
          //         pointHoverRadius: 5,
          //         pointHoverBackgroundColor: lineChartColor[3],
          //         pointHoverBorderColor: "#EEF0F2",
          //         pointHoverBorderWidth: 2,
          //         pointRadius: 1,
          //         pointHitRadius: 10,
          //         data: [80, 23, 56, 65, 23, 35, 85, 25, 92, 36]
          //     }
          // ]
        };
        const option_ = {
          x: {
            ticks: {
              font: {
                family: "Poppins",
              },
            },
          },
          y: {
            ticks: {
              font: {
                family: "Poppins",
              },
            },
          },
          plugins: {
            legend: {
              labels: {
                // This more specific font property overrides the global property
                font: {
                  family: "Poppins",
                },
              },
            },
          },
        };
        chart = <Line data={data_} options={option_} />;
        break;
      case "bar":
        const data__ = {
          labels: data_set.labels,
          datasets: data_set.values.map((item, index) => {
            return {
              label: item.label,
              data: item.data,
            };
          }),
          // datasets: [
          //     {
          //         label: "Sales Analytics",
          //         backgroundColor: barChartColor[0],
          //         borderColor: barChartColor[0],
          //         borderWidth: 1,
          //         hoverBackgroundColor: barChartColor[1],
          //         hoverBorderColor: barChartColor[1],
          //         data: [65, 59, 81, 45, 56, 80, 50, 20]
          //     }
          // ]
        };
        const option__ = {
          x: {
            ticks: {
              font: {
                family: "Poppins",
              },
            },
          },
          y: {
            ticks: {
              font: {
                family: "Poppins",
              },
            },
          },
          plugins: {
            legend: {
              labels: {
                font: {
                  family: "Poppins",
                },
              },
            },
          },
        };
        chart = <Bar data={data__} options={option__} />;
        break;
      case "pie":
        const data = {
            labels: data_set?.data?.map((item) => item.label),
            datasets: [
              {
                data: data_set?.data?.map((item) => item.value),
              },
            ],
          },
          option = {
            plugins: {
              legend: {
                labels: {
                  font: {
                    family: "Poppins",
                  },
                },
              },
            },
          };
        chart = <Pie data={data} options={option} />;
        break;
      case "area_chart":
        chart = (
          <ReactApexChart
            options={{
              ...data_set,
              chart: {
                ...data_set.chart,
                toolbar: { show: true },
              },
            }}
            series={data_set.series}
            type="area"
          />
        );
        break;

      case "bar_with_marker":
        chart = (
          <ReactApexChart
            options={{
              ...data_set,
              chart: {
                ...data_set.chart,
                toolbar: { show: true },
              },
            }}
            series={data_set.series}
            type="bar"
          />
        );
        break;

      case "heatmap":
        chart = (
          <ReactApexChart
            options={{
              ...apexConfigs.heatmap.options,
              chart: {
                ...apexConfigs.heatmap.options?.chart,
                toolbar: { show: true },
              },
            }}
            series={apexConfigs.heatmap.series}
            type="heatmap"
          />
        );
        break;

      case "line_column":
        chart = (
          <ReactApexChart
            options={{
              ...apexConfigs.lineBar.options,
              chart: {
                ...apexConfigs.lineBar.options?.chart,
                toolbar: { show: true },
              },
            }}
            series={apexConfigs.lineBar.series}
            type="line"
          />
        );
        break;

        case "timeseries":
        chart = (
          <Timeseries_chart type="area"/>
        );
        break;

      case "multi_axis_line_chart":
        chart = (
          <ReactApexChart
            options={{
              ...data_set,
              chart: {
                ...data_set.chart,
                toolbar: { show: true },
              },
            }}
            series={data_set.series}
            type="line"
          />
        );
        break;

      case "range_bar":
        chart = (
          <ReactApexChart
            options={{
              ...data_set,
              chart: {
                ...data_set.chart,
                toolbar: { show: true },
              },
            }}
            series={data_set.series}
            type="rangeBar"
          />
        );
        break;

      case "scatter":
        let new_data = reviveFunctions(data_set);

        chart = (
          <ReactApexChart
            options={{
              ...new_data,
              chart: {
                ...new_data.chart,
                toolbar: { show: true },
              },
            }}
            series={new_data.series}
            type="scatter"
          />
        );
        break;

      case "donut":
        chart = (
          <ReactApexChart
            options={{
              ...data_set.data[0],
              chart: {
                ...data_set.data[0].chart,
                toolbar: { show: true },
              },
            }}
            series={data_set.data[0].series}
            type="donut"
          />
        );
        break;

      case "bar_with_stacked":
        chart = (
          <ReactApexChart
            options={{
              ...data_set,
              chart: {
                ...data_set.chart,
                toolbar: { show: true },
              },
            }}
            series={data_set.series}
            type="bar"
          />
        );
        break;
      case "horizontal_bar":
        chart = (
        <HorizontalBarChart  data_set={JSON.parse(JSON.stringify(data_set))} />
        );
        break;
      case "none":
        chart = <TableChart data={table_data} />;
        break;
      default:
        chart = <Line data={lineData} options={chartOptions} />;
    }
  } catch (error) {
    chart = (
      <div style={{ color: "red" }}>
        {" "}
        Something went wrong. Use Another favorite prompt to generate
      </div>
    );
  }

  root.render(chart);
  el.__reactRoot = root;
}

function unmountChartFrom(el) {
  if (el?.__reactRoot) {
    el.__reactRoot.unmount();
    el.__reactRoot = null;
  }
}

const Dashboard_st = () => {
  const [isOpen, setIsOpen] = useState(false);

  const togglePanel = () => setIsOpen((prev) => !prev);
  const dispatch = useDispatch();
  const location = useLocation();
  const { Dashboard_Id } = location.state || {};
  const [selected_dashboard_category, setselected_dashboard_category] =
    useState(null);
  const [search_prompt_description, setsearch_prompt_description] =
    useState(null);
  const {
    dashboard_list,
    dnd_components,
    dashboard_loader,
    drag_drop_canvas_loader,
    dashboard_category,
    group_bot_list,
    fav_prompt_list,
    side_panel_loader,
    new_element,
    temp_title
  } = useSelector((state) => state.Dashboard);
  const [_selected_bot, set_selected_bot] = useState(null);
  const { Favorite_Prompt_Category } = useSelector(
    (state) => state.Favourite_Prompt
  );
  const [title, settitle] = useState(null);

  const [fav_prompt_grouped, setfav_prompt_grouped] = useState([]);

  useEffect(() => {
    dispatch(set_bread_crum({ title: "Dashboard", pageTitle: "Dashboard" }));

    dispatch(reset_group_Owner());

    return () => {
      dispatch(set_bread_crum({ title: "", pageTitle: "" }));
    };
  }, []);

  useEffect(() => {
      dispatch(setnew_element(store.getState().Dashboard.dnd_components))
      console.log("Setting new Elements" , store.getState().Dashboard.dnd_components)
  }, [store.getState().Dashboard.dnd_components , dnd_components])
  

  useEffect(() => {
    console.log("Initializing GRID stack .... ");
    const grid = GridStack.init({
      column: 96,
      row:48,
      acceptWidgets: true,
      cellHeight: '10vh',
      removable: "#trash",
      resizable: { handles: "e, se, s, sw, w" },
      
      float: true,
    });

    gridInstance = grid; // ✅ make available to mountChartInto



    GridStack.setupDragIn(".sidepanel .grid-stack-item", undefined, {
      w: 4,
      h: 5,
      content: '<div className="grid-stack-item-content"></div>',
    });

    grid.on("added", (_e, items) => {
      items.forEach(async (item) => {
        const content = item.el.querySelector(".grid-stack-item-content");
        const chartType = item.el.getAttribute("data-chart") || "line";
        const graph_data = item.el.getAttribute("data-graph");
        const fav_prompt = item.el.getAttribute("data-fav-prompt");

        const { Database_Id, BotFavoritePromptId } = JSON.parse(fav_prompt);

        dispatch(set_drag_drop_canvas_loader(true));

        const element_id = item.el.getAttribute("gs-id");
        let response = dashboard_element({
          element_id: element_id,
          database_id: Database_Id,
          dashboard_id: Dashboard_Id,
          title: store.getState().Dashboard.temp_title,
          graph_element_title: store.getState().Dashboard.temp_title,
          favorite_prompt_id: BotFavoritePromptId,
        });

        const data = await response;
        
                
        
          // dispatch(set_component_to_canvas([...store.getState().Dashboard.dnd_components , {
          //       id: element_id,
          //       type:chartType,
          //       x:0,
          //       y:0,
          //       width: 5,
          //       height: 5,
          //       favorite_prompt_id:BotFavoritePromptId,
          //       title:title,
          //       data:data.graph_json,
          //       Y_Axis_Column: " ",
          //       X_Axis_Column: " ",
          //       Labelling_Column: " ",
          //       Theta_Column:" "
          //   }]))
            console.log("calling new Elements")
        const new_ele = store.getState().Dashboard.new_element

            dispatch(setnew_element([...new_ele, {
                id: element_id,
                type:chartType,
                x:0,
                y:0,
                width: 5,
                height: 5,
                favorite_prompt_id:BotFavoritePromptId,
                title:store.getState().Dashboard.temp_title,
                data:data.graph_json,
                Y_Axis_Column: " ",
                X_Axis_Column: " ",
                Labelling_Column: " ",
                Theta_Column:" "
            }]))
            console.log("Setting new Elements",[...new_ele, {
                id: element_id,
                type:chartType,
                x:0,
                y:0,
                width: 5,
                height: 5,
                favorite_prompt_id:BotFavoritePromptId,
                title:title,
                data:data.graph_json,
                Y_Axis_Column: " ",
                X_Axis_Column: " ",
                Labelling_Column: " ",
                Theta_Column:" "
            }] )

        dispatch(set_drag_drop_canvas_loader(false));
        console.log("Completed Adding new Graph .....");
        
        mountChartInto(content, chartType, JSON.stringify(data.graph_json), store.getState().Dashboard.temp_title , element_id);
        dispatch(set_temp_title(""))
      });
    });

    grid.on("removed", (_e, items) => {
      items.forEach((item) => {
        const content = item.el.querySelector(".grid-stack-item-content");
        unmountChartFrom(content);
      });

      let grid_value = grid.save();
      console.log("Grid Data:", grid_value);
     let temp_dnd_component = grid_value.map((ele) => {
        const new_ele = store.getState().Dashboard.new_element
        console.log(new_ele)
        console.log(ele.id)
        let component_old_data = JSON.parse(
          JSON.stringify(new_ele.find((dnd) => ele.id == dnd.id))
        );
        console.log(component_old_data);

        const { x, y, h, w } = ele;
        component_old_data.x = x;
        component_old_data.y = y;
        component_old_data.height = h;
        component_old_data.width = w;

        return component_old_data;
      });

      dispatch(setnew_element(temp_dnd_component))
      console.log("Setting new elements" , temp_dnd_component);
      
    });

    grid.engine.nodes.forEach((n) => {
      const content = n.el.querySelector(".grid-stack-item-content");
      const chartType = n.el.getAttribute("data-chart") || "area";
      const graph_data = n.el.getAttribute("data-graph") || null;
      const title =  n.el.getAttribute("data-title")
      const gs_id =  n.el.getAttribute("gs-id")

      mountChartInto(content, chartType, graph_data , title , gs_id);
    });

    grid.on("change", () => {
      let grid_value = grid.save();
      console.log("Grid Data:", grid_value);
      let temp_dnd_component = grid_value.map((ele) => {
        const new_ele = store.getState().Dashboard.new_element
        console.log(new_ele)
        console.log(ele.id)
        let component_old_data = JSON.parse(
          JSON.stringify(new_ele.find((dnd) => ele.id == dnd.id))
        );
        console.log(component_old_data);

        const { x, y, h, w } = ele;
        component_old_data.x = x;
        component_old_data.y = y;
        component_old_data.height = h;
        component_old_data.width = w;

        return component_old_data;
      });

      dispatch(setnew_element(temp_dnd_component))
      console.log("Setting new Elements" ,temp_dnd_component )
      
    });

    return () => {
      grid.engine.nodes.forEach((n) => {
        const content = n.el.querySelector(".grid-stack-item-content");
        unmountChartFrom(content);
      });
      grid.destroy(false);
    };
  }, [dashboard_loader ]);

  const handleDashboardSave = () => {
    const new_ele = store.getState().Dashboard.new_element
    const elements = new_ele.map((ele, index) => {
      const {
        id,
        type,
        x,
        y,
        width,
        height,
        title,
        favorite_prompt_id,
        data,
        X_Axis_Column,
        Y_Axis_Column,
        Labelling_Column,
        Theta_Column,
        xPercent,
        yPercent,
      } = ele;

      return {
        element_id: id,
        favorite_prompt_id,
        graph_element_title: title || " ",
        graph_json: data,
        graph_type: type,
        height,
        width,
        x_axis_position: x,
        y_axis_position: y,
        x_axis_column: X_Axis_Column,
        y_axis_column: Y_Axis_Column,
        labelling_column: Labelling_Column,
        theta_column: Theta_Column,
        xPercent,
        yPercent,
      };
    });

    const post_data = {
      dashboard_id: Dashboard_Id,
      elements,
    };

    dispatch(SAVE_DASHBOARD(post_data));
  };

  const setdashboardCategory = (e) => {
    setselected_dashboard_category(e.target.value);

    dispatch(
      GET_DASHBOARD_FAV_PROMPT_LIST({
        group_id: dashboard_list?.data[0]?.Group_Id,
        search_bot_id: _selected_bot,
        search_prompt_category: e.target.value,
        search_prompt_description: search_prompt_description,
      })
    );
  };

  useEffect(() => {
    // Get the dashboard details.
    dispatch(FETCH_DASHBOARD_LIST({ search_dashboard_id: Dashboard_Id }));

    dispatch(GET_DASHBOARD_ELEMENTS({ dashboard_id: Dashboard_Id }));
  }, [Dashboard_Id]);

  useEffect(() => {
    if (dashboard_list.data) {
      // dispatch(bot_list({search_group_id:dashboard_list?.data[0]?.Group_Id}))

      dispatch(
        Get_Favourite_Prompt_Category({
          group_id: dashboard_list?.data[0]?.Group_Id,
        })
      );
      dispatch(
        GET_GROUP_BOT_LIST({ group_id: dashboard_list?.data[0]?.Group_Id })
      );
      dispatch(
        GET_DASHBOARD_FAV_PROMPT_LIST({
          group_id: dashboard_list?.data[0]?.Group_Id,
        })
      );
    }
  }, [dashboard_list]);

  useEffect(() => {
    let grouped_values = groupByPromptCategory(fav_prompt_list);

    console.log(grouped_values);
    setfav_prompt_grouped(grouped_values);
  }, [fav_prompt_list]);

  return (
    <>
      {/* Toggle Button */}
      <div className="new_chart_drag_side_save">
        <Button className="btn-tog" onClick={togglePanel}>
          {isOpen ? (
            <i className=" ri-close-line"></i>
          ) : (
            <i className="ri-add-line"></i>
          )}
        </Button>
        <Button onClick={handleDashboardSave}>Save</Button>
      </div>

      {/* Side Panel */}
      <div className={`sidepanel ${isOpen ? "active" : ""}`} id="panel">
        {side_panel_loader && <N_C_loader />}
        <div className="" style={{ position: "relative" }}>
          <p className="side_heading">
            <b>Create A Dashboard Element</b>
          </p>
          {/* Toggle Button */}
          <Button className="btn-tog" onClick={togglePanel}>
            {isOpen ? (
              <i className=" ri-close-line"></i>
            ) : (
              <i className="ri-add-line"></i>
            )}
          </Button>
          <div className="from">
            <div className="mb-4">
              <Label>Title of the Element</Label>
              <Input
                value={store.getState().Dashboard.temp_title}
                onChange={(e) => {
     
                  dispatch(set_temp_title(e.target.value))

                }}
              ></Input>
            </div>
            <div className="mb-4">
              <Label>Drag the element to the dashboard area</Label>
              <div className="full_w">
                <div className="half">
                  <select
                    onChange={(e) => {
                      set_selected_bot(e.target.value);
                      dispatch(
                        GET_DASHBOARD_FAV_PROMPT_LIST({
                          group_id: dashboard_list?.data[0]?.Group_Id,
                          search_bot_id: e.target.value,
                          search_prompt_category: selected_dashboard_category,
                          search_prompt_description: search_prompt_description,
                        })
                      );
                    }}
                    className="form-select mb-3"
                    aria-label="Default select example"
                  >
                    <option value={""} selected={"" == _selected_bot}>
                      Filter By Bot
                    </option>
                    {group_bot_list.map((ele, key) => {
                      return (
                        <option
                          selected={ele.Bot_Id == _selected_bot}
                          value={ele.Bot_Id}
                        >
                          {ele.Bot_Name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="half">
                  <select
                    onChange={setdashboardCategory}
                    className="form-select mb-3"
                    aria-label="Default select example"
                  >
                    <option
                      selected={"" == selected_dashboard_category}
                      value={""}
                    >
                      Filter by Category{" "}
                    </option>
                    {Favorite_Prompt_Category?.map((ele, key) => {
                      return (
                        <option
                          selected={ele == selected_dashboard_category}
                          key={key}
                          value={ele}
                        >
                          {ele}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="position-relative spn">
                <Input
                  onChange={(e) => {
                    setsearch_prompt_description(e.target.value);
                    dispatch(
                      GET_DASHBOARD_FAV_PROMPT_LIST({
                        group_id: dashboard_list?.data[0]?.Group_Id,
                        search_bot_id: _selected_bot,
                        search_prompt_category: selected_dashboard_category,
                        search_prompt_description: e.target.value,
                      })
                    );
                  }}
                  value={search_prompt_description}
                  placeholder="Search for prompt  description"
                ></Input>
                <span className="mdi mdi-magnify search-widget-icon"></span>
              </div>
            </div>
          </div>
        </div>

        {/* ============== */}

        {Object.entries(fav_prompt_grouped).map(([category, prompts]) => {
          return (
            <div className="compo_chart">
              <p>
                <b>{category}</b>
              </p>

              {prompts.map((ele, key) => {
                // let in_use = dnd_components.find(u => u.favorite_prompt_id === ele.BotFavoritePromptId);
                let in_use = new_element.find(u => u.favorite_prompt_id === ele.BotFavoritePromptId);
                return (
                  <>
                  <span>Visualization : {ele.Visualization}</span>
                  <div
                    className={`grid-stack-item sidepanel-item ${ in_use && 'in-use'}`}
                    gs-w="4"
                    gs-h="5"
                    data-fav-prompt={JSON.stringify(ele)}
                    data-chart={ele.Visualization}
                    gs-id={uuidv4()}
                  >
                    <div className="grid-stack-item-content">
                      {ele.Description}
                    </div>
                    {/* <div className="grid-stack-item-content">
                      <span className="chart_name">Chart Name</span>
                    </div> */}
                  </div>
                  </>
                  
                );
              })}
            </div>
          );
        })}
      </div>

      {/* Grid Canvas */}
      <div className="grid-stack">
        {dnd_components.map((ele, _id) => {
          const {
            type,
            x,
            y,
            title,
            height,
            width,
            data,
            id,
            favorite_prompt_id,
          } = ele;

          return (
            <div
              gs-x={x}
              gs-y={y}
              gs-w={width}
              gs-h={height}
              gs-id={ele.id}
              data-chart={type}
              data-graph={JSON.stringify(data)}
              data-x={x}
              data-y={y}
              data-title={title}
              data-height={height}
              data-width={width}
              className="grid-stack-item"
              id={uuidv4()}
            >
              {/* <div class="grid-stack-item-content"></div> */}
              {/* <N_C_loader /> */}
              <div id={uuidv4()} class="grid-stack-item-content"></div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default function App() {

    const { dashboard_loader, drag_drop_canvas_loader , dashboard_list } = useSelector(
    (state) => state.Dashboard
  );
  // edit title
  const [title, setTitle] = useState("");
  const [tempTitle, setTempTitle] = useState(title); // hold temporary input
  const [isEditing, setIsEditing] = useState(false);
  const { Dashboard_Id } = location.state || {};
  const dispatch = useDispatch()

  const inputRef = useRef(null);

  // Focus input when editing
  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  const handleSave = () => {
    setTitle(tempTitle);
    let form_data = new FormData();
    form_data.append('Dashboard_Title', tempTitle)
    form_data.append('dashboard_id', dashboard_list?.data[0]?.Dashboard_Id)
    console.log(form_data.get("Dashboard_Title"));  // should print tempTitle
    console.log(form_data.get("dashboard_id")); 
    
    dispatch(UPDATE_DASHBOARD_DETAILS(form_data))
    setIsEditing(false);
  };

  const handleCancel = () => {
    setTempTitle(title); // reset back to old title
    setIsEditing(false);
  };

  // end edit title

  const [showLoader, setShowLoader] = useState(true);


  useEffect(() => {
    setShowLoader(true);
  }, []);

  // Listen for dashboard elements loaded
  const dashboardLoaded = useSelector(
    (state) => state.Dashboard.dnd_components?.length > 0
  );

  useEffect(() => {
    if (dashboardLoaded) {
      setShowLoader(false);
    }
  }, [dashboardLoaded]);


  useEffect(() => {
    if(dashboard_list?.data?.length > 0){
      setTitle(dashboard_list?.data[0]?.Dashboard_Title)

    }
  }, [dashboard_list])
  

  return (
     <div className="new_chart_drag">
      {/* Editable Title Section */}
      <RenameModal/>
      {/* edit modal */}
      <Chart_Edit_Values_Popup />
      <div
        className="new_chart_drag_in_tittle"
        style={{ display: "flex", alignItems: "center", gap: "8px", padding: "0px 14px"}}
      >
        {isEditing ? (
          <>
            <div className="edit_tittle_input">
              <p style={{ marginBottom:"5px",fontWeight: "500"}}>Enter new tittle</p>
              <div className="input_btn" style={{display:"flex"}}>
                <input
                ref={inputRef}
                type="text"
                value={tempTitle}
                onChange={(e) => setTempTitle(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSave(); // Save on Enter
                  if (e.key === "Escape") handleCancel(); // Cancel on Escape
                }}
                
              />
              <button
                className="btn btn-secondary"
                onClick={handleSave}
                style={{
                  border: "none",
                  borderRadius: "4px",
                  padding: "4px 10px",
                  cursor: "pointer",
                  marginRight: "8px",
                }}
              >
                Save
              </button>
              <button
              className="btn btn-light"
                onClick={handleCancel}
                style={{
                  border: "none",
                  borderRadius: "4px",
                  padding: "4px 10px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              </div>
            </div>
          </>
        ) : (
          <>
            <h4 className="tittle">{title}</h4>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                setTempTitle(title);
                setIsEditing(true);
              }}
            >
              <i className="ri-pencil-line text-primary"></i> Edit
            </span>
          </>
        )}
      </div>

      {/* Loader + Dashboard */}
      {drag_drop_canvas_loader && <N_C_loader />}
      <Dashboard_st />

    </div>
  );
}

